import { render, staticRenderFns } from "./AppTitleWithIcon.vue?vue&type=template&id=2c0f410f&scoped=true&"
import script from "./AppTitleWithIcon.vue?vue&type=script&lang=js&"
export * from "./AppTitleWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./AppTitleWithIcon.vue?vue&type=style&index=0&id=2c0f410f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0f410f",
  null
  
)

export default component.exports